import requestLaravel from '../laravel-web-app/request';

async function generateToken() {
  return requestLaravel({
    method: 'GET',
    url: '/trigger/generateToken',
    withCredentials: true,
  }).then((response) => response.data);
}

/**
 * DEV4-5013 — a empresa do usuário logado está na nova interface?
 *
 * Endpoint sem efeito colateral, de propósito: o `generateToken` apaga e recria
 * a linha em `trigger_tokens` e emite um Personal Access Token, então não pode
 * ser usado só para descobrir isso — emitir credencial para quem vai ser barrado
 * é o que a correção quer evitar.
 */
async function getTriggerAccess() {
  return requestLaravel({
    method: 'GET',
    url: '/trigger/access',
    withCredentials: true,
  }).then((response) => response.data);
}

export { generateToken, getTriggerAccess };
